let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("jg5LT"), load("ffEVr"), load("7f9Fz"), load("9XYQ9"), load("6Yu8N"), load("6iF9L")]).then(() => parcelRequire('hyBPw'));